import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05caafea")

_pushScopeId("data-v-05caafea")
const _hoisted_1 = { class: "flex_start_center" }
const _hoisted_2 = {
  key: 0,
  src: "https://api-cos.keniu.com/payment/super_vip_title_img.png"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.viewModel.tabs, (item) => {
      return (_openBlock(), _createBlock("li", {
        key: item.type,
        class: { active: $setup.viewModel.type === item.type },
        onClick: ($event: any) => ($setup.switchTab(item.type))
      }, [
        _createTextVNode(_toDisplayString(item.label) + " ", 1),
        (item.isTag)
          ? (_openBlock(), _createBlock("img", _hoisted_2))
          : _createCommentVNode("", true)
      ], 10, ["onClick"]))
    }), 128))
  ]))
})